module.exports = __webpack_public_path__ + "img/button-order.dc7e6e16.png";